import { useState, useEffect } from 'react';
import api from '../services/api';

export default function BugReportsPage() {
    const [reports, setReports] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        api.get('/bug_reports?pagination=false&order[createdAt]=desc')
            .then(res => setReports(res.data.member || []))
            .catch(console.error)
            .finally(() => setLoading(false));
    }, []);

    if (loading) return <div style={{ padding: '24px', color: '#888' }}>Chargement...</div>;

    return (
        <div style={{ padding: '24px', maxWidth: '800px' }}>
            <h2 style={{ margin: '0 0 24px', fontSize: '22px', fontWeight: '700', color: 'var(--text-main)' }}>
                <i className="ti ti-bug" style={{ marginRight: '8px' }} />
                Rapports de bugs ({reports.length})
            </h2>

            {reports.length === 0 ? (
                <div style={{ textAlign: 'center', padding: '40px', color: '#888' }}>
                    <i className="ti ti-check" style={{ fontSize: '32px', display: 'block', marginBottom: '8px' }} />
                    Aucun bug signalé
                </div>
            ) : (
                <div style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
                    {reports.map(r => (
                        <div key={r.id} style={{
                            backgroundColor: 'var(--card-bg)',
                            borderRadius: '12px',
                            padding: '16px 20px',
                            boxShadow: '0 1px 6px rgba(0,0,0,0.07)',
                            borderLeft: '4px solid #ef4444',
                        }}>
                            <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '10px' }}>
                                <span style={{ fontWeight: '700', fontSize: '14px', color: 'var(--text-main)' }}>
                                    <i className="ti ti-user" style={{ marginRight: '6px' }} />
                                    {r.auteur}
                                </span>
                                <span style={{ fontSize: '12px', color: 'var(--text-muted)' }}>
                                    <i className="ti ti-clock" style={{ marginRight: '4px' }} />
                                    {new Date(r.createdAt).toLocaleString('fr-FR')}
                                </span>
                            </div>
                            <div style={{ fontSize: '14px', color: 'var(--text-main)', whiteSpace: 'pre-wrap' }}>
                                {r.message}
                            </div>
                        </div>
                    ))}
                </div>
            )}
        </div>
    );
}